// Chakra imports
import { Flex } from "@chakra-ui/react";
import React from "react";
import { tablesTableData, dashboardTableData } from "../../variables/general";
import UserDetails from "./components/UserDetails";
import { useGetprofileQuery } from "../../api/profile.api";
import { Spinner } from "@chakra-ui/react";

function User() {
  const { data, isLoading } = useGetprofileQuery();
  console.log("isLoading", isLoading);
  return (
    <Flex direction="column" pt={{ base: "120px", md: "85px" }}>
      {isLoading ? (
        <Flex justifyContent="center" alignItems="center">
          <Spinner
          thickness="5px"
          speed="0.65s"
          emptyColor="gray.200"
          color="teal.400"
          size="xl"
          mt ="15%"
        />
        </Flex>
      ) : (
        <UserDetails />
      )}
    </Flex>
  );
}

export default User;
